var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRealestate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11420_4392",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11420_4392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 70V10H40V23.3333H73.3333V70H6.66667ZM13.3333 63.3333H20V56.6667H13.3333V63.3333ZM13.3333 50H20V43.3333H13.3333V50ZM13.3333 36.6667H20V30H13.3333V36.6667ZM13.3333 23.3333H20V16.6667H13.3333V23.3333ZM26.6667 63.3333H33.3333V56.6667H26.6667V63.3333ZM26.6667 50H33.3333V43.3333H26.6667V50ZM26.6667 36.6667H33.3333V30H26.6667V36.6667ZM26.6667 23.3333H33.3333V16.6667H26.6667V23.3333ZM40 63.3333H66.6667V30H40V36.6667H46.6667V43.3333H40V50H46.6667V56.6667H40V63.3333ZM53.3333 43.3333V36.6667H60V43.3333H53.3333ZM53.3333 56.6667V50H60V56.6667H53.3333Z",
    fill: "#191A47"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealestate);
export default __webpack_public_path__ + "static/media/realestate.bda611cd13f57701763e86be449f43f9.svg";
export { ForwardRef as ReactComponent };